import React from 'react';

import Grid from '@material-ui/core/Grid';

import DashboardLayout from './../layouts/dashboard';
import { NotificationsList } from '../../components/Notifications/NotificationsList';

export const NotificationsPage = () => {
  return (
    <DashboardLayout title={'Notificaciones'}>
      <Grid
        container
        spacing={0}
        direction="row"
        alignItems="flex-start"
        justifyContent="flex-start"
        style={{ minHeight: '100vh' }}
      >
        <Grid item xs>
          <NotificationsList />
        </Grid>
      </Grid>
    </DashboardLayout>
  );
};
